import { ActionSeverity, capturePageAction, TeamInfo } from '@chegg/observability';
import { CheggTldRegex } from './constants';
import getCheggTldFrom from './getCheggTldFrom';

/**
 * This function accepts a string that is a url, a hostname, a domain, or tld,
 * and will rewrite the string's top-level domain to match the given
 * target context.  Target context should contain a Chegg top-level domain
 * and can be a tld that starts with '.', a domain, a hostname, a url, or
 * a NextJS context object that contains a Passport header or hostname header.
 * If the function is unable to identify a Chegg TLD in both the source string
 * and the matching context, it will return the original string.
 * @param sourceStr
 * @param matchTarget
 * @returns
 */

function rewriteCheggTldToMatch(sourceStr, matchTarget) {
  if (!sourceStr || !matchTarget) return sourceStr;
  var targetTld = getCheggTldFrom(matchTarget);
  if (!targetTld) return sourceStr;
  var needsPrefix = sourceStr.startsWith('.');
  var needsProtocol = !sourceStr.startsWith('https://');
  var hasTrailingSlash = sourceStr.endsWith('/');
  var cleanUrl = "".concat(needsProtocol ? 'https://' : '').concat(needsPrefix ? 'www' : '').concat(sourceStr);
  try {
    var parsedUrl = new URL(cleanUrl);
    parsedUrl.hostname = parsedUrl.hostname.replace(CheggTldRegex, "$1".concat(targetTld));
    var result = parsedUrl.href;
    if (!hasTrailingSlash && result.endsWith('/')) {
      result = result.slice(0, -1);
    }
    if (needsPrefix) {
      result = result.replace(/^https:\/\/www/, '');
    } else if (needsProtocol) {
      result = result.replace(/^https:\/\//, '');
    }
    return result;
  } catch (error) {
    // sourceStr could not be parsed; do nothing and return whatever was given
    var message = error instanceof Error ? error.message : error;
    capturePageAction({
      action: "Unable to rewrite tld: ".concat(message),
      location: 'rewriteCheggTldToMatch.ts',
      severity: ActionSeverity.INFO
    }, {
      teamName: TeamInfo['FT-Nexus'].name,
      sourceStr: sourceStr
    });
    return sourceStr;
  }
}
export default rewriteCheggTldToMatch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/urls/rewriteCheggTldToMatch.js
// module id = 1258
// module chunks = 11